import { Switch } from "./ui/switch";

export const ConsentToggleRow = ({ label, description, checked, onChange, testId }) => (
  <div className="flex items-start justify-between gap-4 py-4 border-b border-soft-gray" data-testid={testId}>
    <div>
      <p className="font-bold text-sm">{label}</p>
      {description && <p className="text-xs text-midnight-black/60 mt-1">{description}</p>}
    </div>
    <Switch checked={checked} onCheckedChange={onChange} data-testid={`${testId}-switch`} />
  </div>
);
